import React from "react";
import { IDS } from "@/constants/testIds";
import { SectionHeader } from "@/sections/Services";

const groups = [
  {
    label: "Languages",
    slug: "languages",
    items: ["Rust", "TypeScript", "SQL", "Nix", "Terraform", "Typst"],
  },
  {
    label: "Frameworks",
    slug: "frameworks",
    items: [
      "Anchor / Solana SDK",
      "Axum + Aide",
      "Tokio",
      "SQLx",
      "Prost / Buf",
      "Bun / openapi-typescript",
    ],
  },
  {
    label: "Infra",
    slug: "infra",
    items: [
      "Nix flakes + Cachix",
      "process-compose",
      "Postgres + TimescaleDB",
      "redb snapshots / journal",
      "Terraform + Latitude.sh",
      "Nginx + Certbot",
    ],
  },
  {
    label: "Audit & Sec",
    slug: "audit-sec",
    items: [
      "Proptest / Arbitrary",
      "cargo-fuzz / libFuzzer",
      "invariant tests",
      "deterministic replay",
      "Clippy / fmt / flake checks",
      "Sentry + tracing / metrics",
    ],
  },
];

const Stack = () => {
  return (
    <section
      id="stack"
      data-testid={IDS.stack}
      className="relative py-28 lg:py-36 border-t border-[rgba(0,255,65,0.12)]"
    >
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10">
        <SectionHeader
          kicker="// 03 — Stack"
          title="Deterministic Rust core. Solana settlement. Boring infra, sharp guarantees."
          right="ls ./stack"
        />

        <div className="mt-14 grid gap-px bg-[rgba(0,255,65,0.18)] border border-[rgba(0,255,65,0.18)] md:grid-cols-2 lg:grid-cols-4">
          {groups.map((g, i) => (
            <div
              key={g.label}
              data-testid={IDS.stackItem(i)}
              className="bg-[#0a0a0a] p-7 group hover:bg-[#0d0d0d] transition-colors"
            >
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#00FF41]">
                /{g.slug}
              </div>
              <h3 className="mt-3 font-mono text-lg text-white tracking-tight">
                {g.label}
              </h3>
              <ul className="mt-6 space-y-2.5">
                {g.items.map((it) => (
                  <li
                    key={it}
                    className="flex items-center gap-2.5 text-[13px] text-zinc-300"
                  >
                    <span className="text-[#00FF41]">›</span>
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stack;
